import React, { useState } from "react";
import { Table, Typography } from "antd";
import GenericOnClickModal from "../../../buttons/genericOnClickModal";
import CsvUpload from "../../../imports/csvUpload";
import { backendPost } from "../../../../helpers/callBackend";
import { errorMessage } from "../../../../helpers/errorMessageFunc";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

const { Title } = Typography;

const columns = [
    {
        title: "Company Name",
        dataIndex: "companyName",
    },
    {
        title: "Entity Type",
        dataIndex: "entityType",
    },
];

const requiredFields = [
    "companyName",
    "dba",
    "website",
    "ein",
    "phoneNumber",
    "addressLine1",
    "addressLine2",
    "addressCity",
    "addressState",
    "stateOfIncorporation",
    "entityType",
    "contactPersonEmail",
    "officerEmail",
    "beneficialOwnerEmail1",
    "beneficialOwnerEmail2",
    "beneficialOwnerEmail3",
    "beneficialOwnerEmail4",
];
const csvRequirements = {
    companyName: {
        description: 'Official legal name of entity',
        required: true,
        options: [],
        length: 0,
    },
    dba: {
        description: 'Doing business as (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    website: {
        description: 'Main website for entity (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    ein: {
        description: 'Tax ID for entity',
        required: true,
        options: [],
        length: 9,
    },
    phoneNumber: {
        description: 'Main phone number for entity. Format without spaces, dashes, area code, i.e. 1112223344',
        required: true,
        options: [],
        length: 10,
    },
    addressLine1: {
        description: 'Entity address line 1',
        required: true,
        options: [],
        length: 0,
    },
    addressLine2: {
        description: 'Entity address line 2 (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    addressCity: {
        description: 'Entity address city',
        required: true,
        options: [],
        length: 0,
    },
    addressPostalCode: {
        description: 'Entity address postal code, 5-digit format, i.e. 12345',
        required: true,
        options: [],
        length: 5,
    },
    addressState: {
        description: 'Entity address state, two letter format, i.e. NY',
        required: true,
        options: [],
        length: 2,
    },
    stateOfIncorporation: {
        description: 'Entity address line 1',
        required: true,
        options: [],
        length: 0,
    },
    entityType: {
        description: 'Entity type: Corporation, LLC or Partnership',
        required: true,
        options: ["Corporation", "LLC", "Partnership"],
        length: 0,
    },
    contactPersonEmail: {
        description: 'Email of main contact person to interact with entity accounts',
        required: true,
        options: [],
        length: 0,
    },
    officerEmail: {
        description: 'Email of officer named on account',
        required: true,
        options: [],
        length: 0,
    },
    beneficialOwnerEmail1: {
        description: 'Email of who owns 25%+ of entity (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    beneficialOwnerEmail2: {
        description: 'Email of who owns 25%+ of entity (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    beneficialOwnerEmail3: {
        description: 'Email of who owns 25%+ of entity (Optional)',
        required: false,
        options: [],
        length: 0,
    },
    beneficialOwnerEmail4: {
        description: 'Email of who owns 25%+ of entity (Optional)',
        required: false,
        options: [],
        length: 0,
    },
}
const AddEntitiesCsvButton = () => {
    const [csvData, setCsvData] = useState([]);
    const [loading, setLoading] = useState(false);

    const preview = csvData.map((obj) => ({
        companyName: obj.companyName,
        entityType: obj.entityType,
    }));

    const handleSubmit = () => {
        // Check #1: File not blank
        if (csvData.length === 0) {
            return errorMessage("Csv File provided is blank. Please upload a valid csv file.");
        }

        // Check #2: All Columns present
        let sampleRowFromCsv = csvData[0];
        let fieldsFromCsv = Object.keys(sampleRowFromCsv);
        const allFieldsArePresent = requiredFields.every((field) => {
            return fieldsFromCsv.includes(field);
        })
        if (!allFieldsArePresent) {
            return errorMessage(
                "Csv File doesn't contain all the required fields. Please upload a valid csv file. Also check the spelling is same as shown in the bullet points",
                 10
            );
        }

        // Check #3: Each row has correct format of data
        // TODO here

        // send to backend
        backendPost(
            "/api/entity/",
            { csv_data: csvData }
        );
    };

    return (
        <GenericOnClickModal
            size="md"
            button={<Button disableElevation fullWidth size="small" variant="outlined" color="primary" sx={{ fontSize: 14, width: '100px', textTransform: 'none' }}>Upload CSV</Button>}
            modalTitle={"Upload CSV file with holding entities data"}
            modalBody={
                <>
                    <div>
                        <Title level={5}>Please make sure csv file contains all the below mentioned fields!</Title>

                        <ul style={{ display: "flex", flexWrap: "wrap", height: "270px", flexDirection: 'column', gap: "6px" }}>
                            {requiredFields.map((field) => {
                                return <li key={field}>{field}</li>
                            })}
                        </ul>
                    </div>
                    <CsvUpload setCsvData={setCsvData} />

                    {csvData.length > 0 && (
                        <div style={{ margin: "10px 0" }}>
                            <Title level={5}>
                                Are you sure to continue with these entities?{" "}
                            </Title>
                            <Table
                                pagination={{
                                    defaultPageSize: 50,
                                    showSizeChanger: true,
                                }}
                                columns={columns}
                                dataSource={preview}
                                tableLayout="fixed"
                                size="small"
                            />

                            <LoadingButton
                                loading={loading}
                                onClick={handleSubmit}
                                loadingPosition="start"
                                disableElevation fullWidth size="small" variant="contained" color="primary"
                                sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                            >
                                Submit
                            </LoadingButton>
                        </div>
                    )}
                </>
            }
        ></GenericOnClickModal>
    );
};

export default AddEntitiesCsvButton;
